export default {
  // Example nav actions
  REGISTER_SECTION: 'REGISTER_SECTION',
  UNREGISTER_SECTION: 'UNREGISTER_SECTION',

  // Locale actions
  TOGGLE_LOCALE: 'TOGGLE_LOCALE',
};
